"use client"

import { useEffect, useState } from "react"
import { useRouter } from "next/navigation"

import { LogoBadge } from "@/components/brand/logo-badge"
import { useT } from "@/lib/i18n"
import { useAuthStore } from "@/lib/store/auth"
import { useHydrated } from "@/lib/use-hydrated"

export default function SplashScreen() {
  const router = useRouter()
  const t = useT()
  const member = useAuthStore((s) => s.member)
  const hydrated = useHydrated()
  const [isExiting, setIsExiting] = useState(false)

  // Gate navigation on store hydration, not a fixed timer: a returning member
  // drops into /home after a brief brand moment instead of staring at the logo.
  useEffect(() => {
    if (!hydrated) return
    const fade = setTimeout(() => setIsExiting(true), 700)
    const go = setTimeout(() => {
      router.replace(member ? "/home" : "/sign-in")
    }, 1000)
    return () => {
      clearTimeout(fade)
      clearTimeout(go)
    }
  }, [hydrated, member, router])

  return (
    <main className="relative flex flex-1 flex-col items-center justify-center px-5 text-center">
      <div className="relative flex flex-col items-center">
        <div className="psc-maroon-breath" aria-hidden />
        <div className="psc-splash-logo-enter psc-gold-sweep relative rounded-full">
          <LogoBadge size={128} />
        </div>
        <div
          className="psc-splash-fade flex flex-col items-center"
          data-exiting={isExiting}
        >
          <h1
            className="psc-fade-up mt-8 text-[40px] leading-[48px] font-bold tracking-[-0.02em] text-foreground"
            style={{ animationDelay: "200ms" }}
          >
            Pakubuwono
          </h1>
          <p
            className="psc-fade-up text-2xl leading-8 font-bold tracking-[-0.01em] text-primary"
            style={{ animationDelay: "320ms" }}
          >
            Social Club
          </p>
          <p
            className="psc-fade-up mt-3 text-sm leading-5 text-muted-foreground"
            style={{ animationDelay: "440ms" }}
          >
            {t("auth.splash.taglineLine1")}
            <br />
            {t("auth.splash.taglineLine2")}
          </p>
        </div>
      </div>

      <div
        className="psc-splash-fade absolute bottom-16 flex items-center gap-3"
        data-exiting={isExiting}
      >
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="psc-breath-dot"
            style={{ animationDelay: `${i * 200}ms` }}
          />
        ))}
      </div>
    </main>
  )
}
